var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAChat(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 1.5h-13a1 1 0 00-1 1v8a1 1 0 001 1h3v4l4.667-4H14.5a1 1 0 001-1v-8a1 1 0 00-1-1z",
    strokeMiterlimit: 10,
    strokeLinejoin: "round",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxNiAxNiI+PGcgc3Ryb2tlLW1pdGVybGltaXQ9IjEwIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBmaWxsPSJub25lIiBzdHJva2U9ImN1cnJlbnRDb2xvciIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBjbGFzcz0ibmMtaWNvbi13cmFwcGVyIj48cGF0aCBkPSJNMTQuNSwxLjVoLTEzIGMtMC41NTIsMC0xLDAuNDQ4LTEsMXY4YzAsMC41NTIsMC40NDgsMSwxLDFoM3Y0bDQuNjY3LTRIMTQuNWMwLjU1MiwwLDEtMC40NDgsMS0xdi04QzE1LjUsMS45NDgsMTUuMDUyLDEuNSwxNC41LDEuNXoiPjwvcGF0aD4gPC9nPjwvc3ZnPg==";
export { SvgAChat as ReactComponent };